import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";

const VIEW_IS_TRENDING_FOR_YOU_OFFFERING_ENABLED = "view_is_trending_for_you_offfering_enabled";

interface ViewIsTrendingForYouOfferingEnabled extends Query<typeof VIEW_IS_TRENDING_FOR_YOU_OFFFERING_ENABLED> {}

interface ViewIsTrendingForYouOfferingEnabledFunction {
  (): ViewIsTrendingForYouOfferingEnabled;
}

const viewIsTrendingForYouOfferingEnabled: ViewIsTrendingForYouOfferingEnabledFunction = () =>
  query({ name: VIEW_IS_TRENDING_FOR_YOU_OFFFERING_ENABLED });

type ViewIsTrendingForYouOfferingEnabledResult = boolean;

interface IsTrendingForYouOfferingEnabledViewArgs extends CancelableQueryViewArgs {}

interface IsTrendingForYouOfferingEnabledView {
  (args: IsTrendingForYouOfferingEnabledViewArgs): Promise<ViewIsTrendingForYouOfferingEnabledResult>;
}

interface ViewIsTrendingForYouOfferingEnabledHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: IsTrendingForYouOfferingEnabledView;
}

const viewIsTrendingForYouOfferingEnabledHandler: QueryHandlerFunction<
  ViewIsTrendingForYouOfferingEnabled,
  ViewIsTrendingForYouOfferingEnabledResult,
  ViewIsTrendingForYouOfferingEnabledHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async () =>
    view({ signal });

export type { IsTrendingForYouOfferingEnabledView, ViewIsTrendingForYouOfferingEnabledResult };
export {
  VIEW_IS_TRENDING_FOR_YOU_OFFFERING_ENABLED,
  viewIsTrendingForYouOfferingEnabled,
  viewIsTrendingForYouOfferingEnabledHandler,
};
